export default __webpack_public_path__ + "dist/media/Avtar1.92fe4339.png";